<style scoped>
    .edit-line{
        display: table;
        width: 100%;
        padding: 1px;
    }
    .edit-line-item{
        display: table-cell;
    }
    .edit-line-title{
        width: 100px;
        padding: 0 8px;
        text-align: right;
    }
    .edit-line-item .ivu-input-number{
        width: 100%;
    }
</style>
<template>
  <div>
    <Table
      size="small"
      border
      stripe
      :columns="columns"
      :data="table_data"
      :loading="loading"
    />

    <Modal
      v-model="edit_config.modal"
      :title="edit_title"
      width="500"
      :loading="edit_config.loading"
      ok-text="保存"
      @on-ok="editOK"
    >
      <div v-if="edit_data.data_type">
        <div
          v-for="(value_object, course_id) in edit_data"
          v-show="isNumber(course_id)"
          class="edit-line"
        >
          <span class="edit-line-item edit-line-title">
            {{ getCourseName(course_id) }}
          </span>
          <span class="edit-line-item">
            <i-input
              v-if="edit_data.data_type === 'string'"
              v-model="edit_data[course_id].string_value"
            />
            <i-input
              v-else
              v-model="edit_data[course_id].number_value"
              number
            />
          </span>
        </div>
      </div>
    </Modal>

    <Modal
      v-model="edit_course_config.modal"
      :title="edit_course_title"
      width="500"
      :loading="edit_course_config.loading"
      ok-text="保存"
      @on-ok="editCourseOK"
    >
      <div v-if="edit_course_data.type_datas.length">
        <div
          v-for="(type_data, index) in edit_course_data.type_datas"
          class="edit-line"
        >
          <span class="edit-line-item edit-line-title">
            {{ getTypeName(type_data.course_data_type_id) }}
          </span>
          <span class="edit-line-item">
            <i-input
              v-if="type_data.data_type === 'string'"
              v-model="type_data.value.string_value"
            />
            <i-input
              v-else
              v-model="type_data.value.number_value"
              number
            />
          </span>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script route="/course_report/manual_input">
  import TermPicker from './components/term_picker';
  export default {
    /* router_info_start */
    router_info: '/course_report/manual_input',
    /* router_info_end */
    components: { TermPicker },
    data() {
      return {
        params: {
          term: ''
        },
        manual_types: [],
        manual_types_hash: {},
        courses: [],
        courses_hash: {},
        manual_data: [],
        loading: false,
        edit_data: {},
        edit_config: {
          modal: false,
          loading: true
        },
        edit_course_data: {
          type_datas: []
        },
        edit_course_config: {
          modal: false,
          loading: true
        }
      }
    },
    computed: {
      columns() {
        const columns = [
          {
            title: '#',
            width: 170,
            fixed: 'left',
            align: 'center',
            renderHeader: (h, params) => {
              const ret = [
                h(TermPicker, {
                  attrs: {
                    style: 'width: 100px',
                    placeholder: '选择期数',
                  },
                  props: {
                    size: 'small',
                    type: 'year',
                    value: this.getTerm()
                  },
                  on: {
                    'on-change': (term) => {
                      this.params.term = term;
                      this.loadData();
                    }
                  }
                }),
                h('span', ' '),
                h('Button', {
                  props: {
                    size: 'small',
                    type: 'primary'
                  },
                  on: {
                    click: () => {
                      this.loadData();
                    }
                  }
                }, '确定')
              ];
              return h('div', {
                'class': {
                  'text-center': true
                }
              }, ret);
            },
            render:(h, params) => {
              const row = params.row;
              const type_name = this.getTypeName(row.course_data_type_id);
              const type_name_tip = this.getTypeNameTip(row.course_data_type_id);
              if (type_name_tip) {
                return h('Tooltip', {
                  props: {
                    content: type_name_tip,
                    transfer: true,
                    placement: 'top'
                  }
                }, [
                  h('span', type_name + ' '),
                  h('Icon', {
                    props: {
                      type: 'md-help-circle',
                      size: 12
                    }
                  })
                ]);
              } else {
                return h('span', type_name);
              }
            }
          }
        ];
        this.courses.forEach((course) => {
          const column_data = {
            title: course.name,
            width: 150,
            align: 'center',
            renderHeader: (h, params) => {
              return h('div', [
                h('span', course.name + ' '),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editCourseData(course.id);
                    }
                  }
                }, '填写')
              ])
            },
            render: (h, params) => {
              const row = params.row;
              let value_obj = row[course.id];
              value_obj = value_obj ? value_obj : {number_value: 0, string_value: ''};
              let value = '';
              if (row.data_type === 'string') {
                value = value_obj.string_value;
              } else {
                value = value_obj.number_value;
                if (!value || value === '0.0') {
                  value = '-';
                } else if (row.data_type === 'decimal') {
                  value = Util.formatDecimal(value);
                } else if (row.data_type === 'int') {
                  value = Util.formatNumber(value);
                } else if (row.data_type === 'percent') {
                  value = `${Util.formatDecimal(value)}%`;
                }
              }
              return h('div', {
                'class': {
                  'text-right': row.data_type !== 'string'
                }
              }, value);
            }
          };
          columns.push(column_data);
        });
        /*columns.push({
                    title: '操作',
                    width: 120,
                    fixed: 'right',
                    align: 'center',
                    render: (h, params)=>{
                        let ret = [];
                        let row = params.row;
                        ret.push(h('Button', {
                            props: {
                                size: 'small',
                                type: 'text'
                            },
                            on: {
                                click: ()=>{
                                    this.editData(params.row);
                                }
                            }
                        }, '填写'));
                        return h('div', ret);
                    }
                });*/
        return columns;
      },
      table_data() {
        const data = [];
        this.manual_data.forEach((type_data) => {
          const row_data = type_data;
          this.courses.forEach((course) => {
            if (!row_data[course.id]) {
              row_data[course.id] = {number_value: 0, string_value: ''}
            }
          });
          data.push(row_data);
        });
        console.log(data);
        return data;
      },
      edit_title() {
        return `第 ${this.edit_data.term} 期 - ${this.getTypeName(this.edit_data.course_data_type_id)}`
      },
      edit_course_title() {
        return `第 ${this.edit_course_data.term} 期 - ${this.getCourseName(this.edit_course_data.course_id)}`
      }
    },
    created() {
      this.getManualTypes();
      this.getCourses();
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        this.params.term = this.getTerm();
        this.loadData();
      },
      loadData() {
        this.getManualData();
      },
      getManualTypes() {
        Util.ajax.get(Util.api.get_course_data_types, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const course_data_types = res.data.course_data_types;
            this.handleTypes(course_data_types);
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      handleTypes(course_data_types) {
        course_data_types.forEach((course_data_type) => {
          this.manual_types.push(course_data_type);
          this.manual_types_hash[course_data_type.id] = course_data_type;
          if (course_data_type.course_data_types.length) {
            this.handleTypes(course_data_type.course_data_types);
          }
        });
      },
      getCourses() {
        Util.ajax.get(Util.api.get_courses, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const courses = res.data.courses;
            courses.forEach((course) => {
              this.courses.push(course);
              this.courses_hash[course.id] = course;
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      getManualData() {
        this.loading = true;
        Util.ajax.get(Util.api.course_manual_data, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          this.manual_data = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((type_data) => {
              this.manual_data.push(type_data);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          console.log(e);
        });
      },
      getCourseName(id) {
        const course = this.courses_hash[id];
        return course ? course.name : '-';
      },
      getTypeName(id) {
        const type = this.manual_types_hash[id];
        return type ? type.name : '-';
      },
      getTypeNameTip(id) {
        const type = this.manual_types_hash[id];
        return type ? type.name_tip : '-';
      },
      getTerm() {
        return 1;
      },
      isNumber(str) {
        const reg = /^(-?\d+)(\.\d+)?$/;
        return reg.test(str);
      },
      editData(course_data) {
        console.log(course_data);
        this.edit_data = Util.clone(course_data);
        this.edit_config.modal = true;
      },
      editOK() {
        Util.ajax.post(Util.api.update_course_manual_data, {
          course_data_type_id: this.edit_data.course_data_type_id,
          term: this.edit_data.term,
          data: this.edit_data
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.edit_config.modal = false;
            this.loadData();
            this.$Message.success('填写成功!');
          } else {
            this.edit_config.loading = false;
            setTimeout(() => {
              this.edit_config.loading = true;
            }, 500);
            this.$Message.error(data.msg);
          }
        }).catch((e) => {
          console.log(e);
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          this.$Message.error('删除失败' + e);
        });
      },
      editCourseData(course_id) {
        this.edit_course_data = {course_id: course_id, term: this.params.term, type_datas: []};
        this.table_data.forEach((data) => {
          const type_data = {
            term: data.term,
            course_id: course_id,
            data_type: data.data_type,
            course_data_type_id: data.course_data_type_id,
            value: data[course_id]
          };
          this.edit_course_data.type_datas.push(type_data);
        });
        this.edit_course_config.modal = true;
      },
      editCourseOK() {
        Util.ajax.post(Util.api.update_manual_course_data, this.edit_course_data).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.edit_course_config.modal = false;
            this.loadData();
            this.$Message.success('填写成功!');
          } else {
            this.edit_course_config.loading = false;
            setTimeout(() => {
              this.edit_course_config.loading = true;
            }, 500);
            this.$Message.error(data.msg);
          }
        }).catch((e) => {
          console.log(e);
          this.edit_course_config.loading = false;
          setTimeout(() => {
            this.edit_course_config.loading = true;
          }, 500);
          this.$Message.error('删除失败' + e);
        });
      }
    }
  }
</script>
